import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7c568d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "maintenance-control"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "系统维护", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-tip" }, "维护期间访问此地址，使用平台超级管理员账号验证后可关闭维护。", -1))
const _hoisted_5 = { class: "maintenance-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolOutlined = _resolveComponent("ToolOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_PlatformOperationVerification = _resolveComponent("PlatformOperationVerification")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.allowed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {
          openPanel: _ctx.openPanel,
          enabled: _ctx.config.enabled
        }, () => [
          _createVNode(_component_a_tooltip, { title: "系统维护" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                class: "maintenance-trigger",
                type: "text",
                onClick: _ctx.openPanel
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_ToolOutlined)
                ]),
                default: _withCtx(() => [
                  _hoisted_2,
                  (_ctx.config.enabled)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ], true),
        _createVNode(_component_a_modal, {
          visible: _ctx.visible,
          "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.visible) = $event)),
          title: "系统维护",
          footer: null,
          width: 620,
          "mask-closable": false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_spin, {
              spinning: _ctx.loading || _ctx.saving
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_alert, {
                  type: _ctx.config.enabled ? 'warning' : 'info',
                  message: _ctx.config.enabled ? '维护模式已开启' : '当前正常运行',
                  description: _ctx.config.enabled
            ? '除本标签页和应急入口外，平台、分店、网页端、管理端及小程序将在检查状态后显示维护页。'
            : '开启后仅限制各端界面访问，不会停止或拦截后端接口。',
                  "show-icon": ""
                }, null, 8, ["type", "message", "description"]),
                _createVNode(_component_a_form, {
                  onFinishFailed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$operationFormFailure($event))),
                  class: "maintenance-form",
                  layout: "vertical"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "维护页标题",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.draft.title,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft.title) = $event)),
                          maxlength: 40,
                          "show-count": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, {
                      label: "维护说明",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: _ctx.draft.message,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.draft.message) = $event)),
                          maxlength: 500,
                          rows: 6,
                          "show-count": "",
                          placeholder: "请输入维护期间向用户显示的说明"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, { label: "应急管理入口" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.recoveryUrl,
                          readonly: ""
                        }, {
                          addonAfter: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "copy-link",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyRecoveryUrl && _ctx.copyRecoveryUrl(...args)))
                            }, "复制")
                          ]),
                          _: 1
                        }, 8, ["value"]),
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.visible)
                  ? (_openBlock(), _createBlock(_component_PlatformOperationVerification, {
                      key: 0,
                      code: _ctx.verificationCode,
                      "onUpdate:code": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.verificationCode) = $event)),
                      receiverId: _ctx.receiverId,
                      "onUpdate:receiverId": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.receiverId) = $event)),
                      disabled: _ctx.saving || _ctx.loading
                    }, null, 8, ["code", "receiverId", "disabled"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_button, {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.visible=false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("关闭窗口")
                    ]),
                    _: 1
                  }),
                  (_ctx.config.enabled)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        onClick: _ctx.saveMessage
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("保存文案")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.config.enabled)
                    ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                        key: 1,
                        title: "确认关闭维护并恢复所有终端访问吗？",
                        "ok-text": "确认关闭",
                        "cancel-text": "取消",
                        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changeMaintenance(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, { type: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode("关闭维护")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_popconfirm, {
                        key: 2,
                        title: "确认开启系统维护吗？",
                        "ok-text": "确认开启",
                        "cancel-text": "取消",
                        onConfirm: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeMaintenance(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            danger: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("开启系统维护")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ])
              ]),
              _: 1
            }, 8, ["spinning"])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}